import ActiveRecord, { sources } from '@mysidewalk/active-record';

import { API_ROOT } from '../settings';

/**
 * @property {number} id
 * @property {string} name
 */
class Organization extends ActiveRecord {}

Organization.$AR = {
  url: `${API_ROOT}/org/v1/organizations`,
  SourceClass: sources.ActiveRecordJSONAPISource,
};

export default Organization;
